import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { useLocation, useNavigate } from 'react-router-dom'
import Completion from './completion' // Import the Completion component
import { selectors } from '../../selectors'
import QuestionTypeBox from '../../../../components/QuestionTypeBox'
import AudioPlayer from '../../../../components/AudioPlayer'
import {
  submitAssessment,
  uploadVideoResponse,
  uploadAudioResponse,
} from '../../actions'
import RecordIcon from '../../../../components/icons/RecordIcon'
import { saveQuestionResponse } from '../../actions'
import DeleteImage from '../../../../components/Images/OBJECTS.png'
import { Button } from 'antd'
import SuccessModal from '../../../../components/SuccessModal'
import {
  PageContainer,
  ContentWrapper,
  Header,
  Title,
  SectionTitle,
  AssessmentTimer,
  ModalOverlay,
  ModalContent,
  Section,
  Paragraph,
  NavigationSection,
  VideoOverlay,
  VideoContainer,
  VideoElement,
  VideoControls,
  ControlButtons,
  RecordButton,
  StopButton,
  VideoInfo,
  Note,
  RecordedVideo,
  DeleteButton,
  Question,
  QuestionText,
  Options,
  Option,
  NavigationButtons,
  StyledButton,
  ShortListModalImg,
  ModalText,
  AudioContainer,
  AudioPreview,
  RecordingControls,
  QuestionInstruction,
  InstructionSection,
  List,
  ListItem,
  StyledDivider,
  RedRecordButton
} from '../../Style'
import { ButtonDiv } from '../../../Events/Preview/Partials/PreviewBox/style'

const DisabledQuestion = styled(Question)`
  opacity: 0.5;
  pointer-events: none;
`

const CommunicationAssessment = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [videoBlob, setVideoBlob] = useState(null)
  const [recording, setRecording] = useState(false)
  const [completedAudioSections, setCompletedAudioSections] = useState([])
  const [stream, setStream] = useState(null)
  const [recordedVideo, setRecordedVideo] = useState(null)
  const [mediaRecorder, setMediaRecorder] = useState(null)
  const [remainingAttempts, setRemainingAttempts] = useState(3)
  const [recordingTime, setRecordingTime] = useState(0)
  const [showOverlay, setShowOverlay] = useState(false)
  const videoRef = useRef(null)
  const chunks = useRef([])
  const timerRef = useRef(null)
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const assessment = location.state?.assessmentData
  const questionsBehaviourArray = useSelector(selectors.getQuestions)
  const questions = questionsBehaviourArray.communications || []
  const [currentPage, setCurrentPage] = useState(0)
  const [timeLeft, setTimeLeft] = useState(15 * 60) // 10 minutes in seconds
  // const [timeLeft, setTimeLeft] = useState(10) // 10 minutes in seconds
  const [audioRecording, setAudioRecording] = useState(false)
  const [audioStream, setAudioStream] = useState(null)
  const [audioRecorder, setAudioRecorder] = useState(null)
  const [audioBlob, setAudioBlob] = useState(null)
  const [audioRemainingAttempts, setAudioRemainingAttempts] = useState(1)
  const audioChunks = useRef([])
  const [audioBlobUrl, setAudioBlobUrl] = useState(null)
  const [audioPositions, setAudioPositions] = useState({});
  const [visitedSections, setVisitedSections] = useState([]);
  const [remainingRecordingTime, setRemainingRecordingTime] = useState(MAX_RECORDING_TIME);
  // Local flag to switch to the Completion component
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isCompleted, setIsCompleted] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [timeUp, setTimeUp] = useState(false)

  // Prevent accidental exit during active assessment (reload, back button, tab close)
  useEffect(() => {
    if (isCompleted) return;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };

    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isCompleted])

  const studentDetails = useSelector(state => state.studentData.studentDetails)
  const MAX_RECORDING_TIME = 120;
  const currentAssessment = useSelector(
    state => state.assessment.currentAssessment
  )
  const [responses, setResponses] = useState({
    paragraphReading: [],
    audioQuestion: [],
    videoResponse: [],
  })

  // Helper: Check if a section is completely answered
  const isSectionAnswered = section => {
    if (section.type === 'Video Response') {
      return recordedVideo !== null
    } else if (section.type === 'Paragraph Reading') {
      const typeKey = 'paragraphReading'
      const sectionResponse = responses[typeKey].find(
        r => r.questionId === section.questionId
      )
      const questionsAnswered =
        sectionResponse &&
        section.questions.every(q =>
          sectionResponse.responses.some(
            r => r.subQuestionId === q.id && r.selectedOption
          )
        )
      return audioBlob !== null && questionsAnswered
    } else {
      const typeKey = 'audioQuestion'
      const sectionResponse = responses[typeKey].find(
        r => r.questionId === section.questionId
      )
      if (!sectionResponse) return false
      return section.questions.every(q =>
        sectionResponse.responses.some(
          r => r.subQuestionId === q.id && r.selectedOption
        )
      )
    }
  }

  // Helper: Check if the entire assessment is complete
  const isAssessmentComplete = () => {
    return questions.every(section => isSectionAnswered(section))
  }

  // Update recording time while recording
  // useEffect(() => {
  //   if (recording) {
  //     const timer = setInterval(() => {
  //       setRecordingTime(prev => prev + 1)
  //     }, 1000)
  //     return () => clearInterval(timer)
  //   }
  // }, [recording])

  useEffect(() => {
    if (recording) {
      setRemainingRecordingTime(MAX_RECORDING_TIME);

      const timer = setInterval(() => {
        setRemainingRecordingTime(prev => {
          if (prev <= 1) {
            // Time's up - stop recording automatically
            stopRecording();
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [recording]);

  useEffect(() => {
    return () => {
      if (stream) {
        stream.getTracks().forEach(track => track.stop())
      }
      if (timerRef.current) {
        clearInterval(timerRef.current)
      }
    }
  }, [stream])

  const startRecording = async () => {
    try {
      setShowOverlay(true)
      setRemainingRecordingTime(MAX_RECORDING_TIME);
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      })
      setStream(mediaStream)
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream
      }
      const recorder = new MediaRecorder(mediaStream)
      setMediaRecorder(recorder)
      recorder.ondataavailable = e => {
        if (e.data.size > 0) {
          chunks.current.push(e.data)
        }
      }
      recorder.onstop = () => {
        const blob = new Blob(chunks.current, { type: 'video/webm' })
        const url = URL.createObjectURL(blob)
        setRecordedVideo(url)
        chunks.current = []
        setRemainingAttempts(prev => prev - 1)
        // Stop all tracks
        mediaStream.getTracks().forEach(track => track.stop())
        setStream(null)
        setRecording(false)
        setShowOverlay(false)
        setVideoBlob(blob)
        setRecordingTime(0)
      }
      setRecordingTime(0)
      setRecording(true)
      recorder.start()
    } catch (err) {
      console.error('Error accessing camera:', err)
      setRecording(false)
      setShowOverlay(false)
      if (timerRef.current) {
        clearInterval(timerRef.current)
      }
      setRecordingTime(0)
    }
  }

  const stopRecording = () => {
    if (mediaRecorder && mediaRecorder.state !== 'inactive') {
      mediaRecorder.stop()
    }
  }

  const handleCloseModal = () => {
    setIsModalVisible(false)
  }

  const handleAudioComplete = (sectionId) => {
    setCompletedAudioSections(prev => [...prev, sectionId])
  }

  const handleAudioProgress = (sectionId, currentTime) => {
    setAudioPositions(prev => ({
      ...prev,
      [sectionId]: currentTime
    }));
  };
  const handleConfirmDelete = () => {
    deleteRecording()
    setIsModalVisible(false)
    setShowSuccessModal(true)
  }

  const handleDeleteClick = () => {
    setIsModalVisible(true)
  }

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false)
  }

  const deleteRecording = () => {
    if (recordedVideo) {
      URL.revokeObjectURL(recordedVideo)
      setRecordedVideo(null)
    }
  }

  const startAudioRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      setAudioStream(stream)
      const recorder = new MediaRecorder(stream)
      setAudioRecorder(recorder)
      audioChunks.current = []

      recorder.ondataavailable = e => {
        if (e.data.size > 0) {
          audioChunks.current.push(e.data)
        }
      }

      recorder.onstop = () => {
        const blob = new Blob(audioChunks.current, { type: 'audio/webm' })
        console.log('Audio blob:', blob)
        setAudioBlob(blob)
        const url = URL.createObjectURL(blob)
        setAudioBlobUrl(url)
        setAudioRemainingAttempts(prev => prev - 1)
      }

      recorder.start()
      setAudioRecording(true)
    } catch (error) {
      console.error('Error accessing microphone:', error)
    }
  }

  const stopAudioRecording = () => {
    if (audioRecorder && audioRecorder.state !== 'inactive') {
      audioRecorder.stop()
      audioStream.getTracks().forEach(track => track.stop())
      setAudioRecording(false)
    }
  }

  useEffect(() => {
    return () => {
      if (audioBlobUrl) {
        URL.revokeObjectURL(audioBlobUrl)
      }
    }
  }, [audioBlobUrl])

  // const formatRecordingTime = seconds => {
  //   const mins = Math.floor(seconds / 60)
  //   const secs = seconds % 60
  //   return `${mins.toString().padStart(2, '0')}:${secs
  //     .toString()
  //     .padStart(2, '0')}`
  // }

  const formatRecordingTime = seconds => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // On submit, if the assessment is incomplete, switch to the first incomplete section
  const handleSubmit = async () => {
    if (!timeUp && !isAssessmentComplete()) {
      const incompleteIndex = questions.findIndex(
        section => !isSectionAnswered(section)
      )
      if (incompleteIndex !== -1) {
        const incompleteSection = questions[incompleteIndex]
        setCurrentPage(incompleteIndex)

        // Show specific messages for different section types
        if (incompleteSection.type === 'Paragraph Reading' && !audioBlob) {
          alert(
            'Please record yourself reading the paragraph before submitting.'
          )
        } else if (
          incompleteSection.type === 'Video Response' &&
          !recordedVideo
        ) {
          alert('Please record your video response before submitting.')
        }
        return
      }
      return
    }
    try {
      setIsSubmitting(true)
      if (recordedVideo) {
        const currentQuestion = currentSection.questions[0]
        await dispatch(uploadVideoResponse(videoBlob, currentQuestion.id))
      }
      if (audioBlob) {
        await dispatch(uploadAudioResponse(audioBlob))
      }
      await dispatch(submitAssessment())
      setIsCompleted(true)
      setIsSubmitting(false)
    } catch (e) {
      console.error('Submit error:', e)
      alert('Failed to submit assessment. Please try again.')
    }
  }

  // If time is up, auto-submit and switch to the Completion component
  const handleTimeUp = async () => {
    try {
      setTimeUp(true)
      await handleSubmit()
      setIsCompleted(true)
    } catch (error) {
      console.error('Auto-submit error:', error)
      alert('Time is up! Assessment auto-submitted.')
      setIsCompleted(true)
    }
  }

  const formatTime = seconds => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
      .toString()
      .padStart(2, '0')}`
  }

  // Main timer for the assessment
  useEffect(() => {
    if (isCompleted) return // Stop timer if assessment is completed

    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer)
          handleTimeUp()
          return 0
        }
        return prevTime - 1
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [isCompleted])

  useEffect(() => {
    if (!assessment) {
      navigate('/assessment')
      return
    }
  }, [assessment, navigate])

  // Show loading if questions are not yet available
  if (!questions || questions.length === 0) {
    return <div>Loading...</div>
  }

  const handlePrevious = () => {
    setCurrentPage(prev => Math.max(0, prev - 1))
  }

  const handleNext = () => {
    if (!visitedSections.includes(currentPage)) {
      setVisitedSections(prev => [...prev, currentPage]);
    }
    setCurrentPage(prev => Math.min(questions.length - 1, prev + 1));
  };
  const handleOptionSelect = (questionId, subQuestionId, selectedOption) => {
    // Mark section as visited when any option is selected
    if (!visitedSections.includes(currentPage)) {
      setVisitedSections(prev => [...prev, currentPage]);
    }

    const questionType =
      currentSection.type === 'Paragraph Reading'
        ? 'paragraphReading'
        : 'audioQuestion'

    setResponses(prev => {
      const existingQuestionIndex = prev[questionType].findIndex(
        q => q.questionId === questionId
      )
      if (existingQuestionIndex > -1) {
        const updatedResponses = [...prev[questionType]]
        const existingSubQuestionIndex = updatedResponses[
          existingQuestionIndex
        ].responses.findIndex(r => r.subQuestionId === subQuestionId)
        if (existingSubQuestionIndex > -1) {
          updatedResponses[existingQuestionIndex].responses[
            existingSubQuestionIndex
          ].selectedOption = selectedOption
        } else {
          updatedResponses[existingQuestionIndex].responses.push({
            subQuestionId,
            selectedOption,
          })
        }
        return {
          ...prev,
          [questionType]: updatedResponses,
        }
      }
      return {
        ...prev,
        [questionType]: [
          ...prev[questionType],
          {
            questionId,
            responses: [
              {
                subQuestionId,
                selectedOption,
              },
            ],
          },
        ],
      }
    })

    dispatch(
      saveQuestionResponse(
        questionId,
        selectedOption,
        currentAssessment.assessment_assigned_id,
        subQuestionId,
        questionType
      )
    )
  }
  const currentSection = questions[currentPage]

  const renderVideoSection = () => {
    return (
      <Section>
        {isModalVisible && (
          <ModalOverlay onClick={handleCloseModal}>
            <ModalContent onClick={e => e.stopPropagation()}>
              <ShortListModalImg>
                <img src={DeleteImage} alt="delete confirmation" />
              </ShortListModalImg>
              <ModalText>
                Are you sure you want to delete this recording?
              </ModalText>
              <ButtonDiv>
                <Button
                  type="default"
                  onClick={handleCloseModal}
                  style={{
                    height: '38px',
                    marginRight: '10px',
                    borderRadius: '4px',
                  }}
                >
                  No
                </Button>
                <Button
                  type="primary"
                  onClick={handleConfirmDelete}
                  style={{
                    height: '38px',
                    borderRadius: '4px',
                    background: '#4318FF',
                  }}
                >
                  Yes
                </Button>
              </ButtonDiv>
            </ModalContent>
          </ModalOverlay>
        )}
        {showSuccessModal && (
          <SuccessModal
            open={showSuccessModal}
            onCloseClick={handleSuccessModalClose}
            message="Recording deleted successfully!"
            title="Delete Recording"
          />
        )}

        {currentSection.paragraph && (
          <Paragraph>
            {formatParagraphWithSpacing(currentSection.paragraph).map(
              (para, index) => (
                <React.Fragment key={index}>
                  {para}
                  {index <
                    formatParagraphWithSpacing(currentSection.paragraph).length -
                    1 && <div style={{ margin: '1rem 0' }}></div>}
                </React.Fragment>
              )
            )}
          </Paragraph>
        )}
        {showOverlay && (
          // <VideoOverlay>

          //   <VideoContainer>
          //     <VideoElement ref={videoRef} autoPlay muted playsInline />
          //     <VideoControls>
          //       <VideoInfo>
          //         Date: {new Date().toLocaleDateString()}
          //         <br />
          //         Time: {new Date().toLocaleTimeString()}
          //       </VideoInfo>
          //       <ControlButtons>
          //         <StopButton onClick={stopRecording}>
          //           <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          //             <rect x="3" y="3" width="10" height="10" fill="white" />
          //           </svg>
          //         </StopButton>
          //       </ControlButtons>
          //       <VideoInfo>{formatRecordingTime(recordingTime)}</VideoInfo>
          //     </VideoControls>
          //   </VideoContainer>
          // </VideoOverlay>

          <VideoOverlay>
            <VideoContainer>
              <VideoElement ref={videoRef} autoPlay muted playsInline />
              <VideoControls>
                <VideoInfo>{formatRecordingTime(remainingRecordingTime)}</VideoInfo>
                <ControlButtons>
                  <StopButton onClick={stopRecording}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <rect x="3" y="3" width="10" height="10" fill="white" />
                    </svg>
                  </StopButton>
                </ControlButtons>
              </VideoControls>
            </VideoContainer>
          </VideoOverlay>
        )}
        <div>
          {!recordedVideo ? (
            <RedRecordButton
              onClick={startRecording}
              disabled={remainingAttempts === 0 || recording || showOverlay}
            >
              <RecordIcon />
              {remainingAttempts === 0
                ? "No attempts left"
                : recording
                  ? "Recording in progress..."
                  : "Record Video Response"}
            </RedRecordButton>
          ) : (
            <RecordedVideo>
              <span>
                {studentDetails.firstName}
                {studentDetails.lastName ? `_${studentDetails.lastName}` : ''}
                .mp4
              </span>
              <DeleteButton onClick={handleDeleteClick}>Delete</DeleteButton>
            </RecordedVideo>
          )}
        </div>
        {!recording && (
          <>
            <br />
            <Note>
              Note: You can re-record your response {remainingAttempts} times
              only, so please make sure you're happy with your answer before
              hitting record!
            </Note>
          </>
        )}
      </Section>
    )
  }
  const formatParagraphWithSpacing = text => {
    if (!text) return ''
    const sentences = text.split('. ')
    const formattedParagraphs = []

    for (let i = 0; i < sentences.length; i += 3) {
      const paragraph = sentences.slice(i, i + 3).join('. ')
      formattedParagraphs.push(
        paragraph + (i + 3 < sentences.length ? '.' : '')
      )
    }

    return formattedParagraphs
  }

  const SectionInstructions = ({ sectionType }) => {
    let instructions = null;
    const sectionDivider = {
      border: "none",
      height: "3px", // Thicker line
      backgroundColor: "#e0e0e0",
      margin: "20px 0",
      width: "100%"
    };

    switch (sectionType) {
      case 'Paragraph Reading':
        instructions = (
          <>
            <SectionTitle>Paragraph Reading Instructions</SectionTitle>
            <List>
              <ListItem>Read the paragraph aloud clearly and at a natural pace</ListItem>
              <ListItem>Record yourself reading the paragraph using the recording button</ListItem>
              <ListItem>You will have one chance to record, so ensure your environment is quiet</ListItem>
              <ListItem>After reading, answer the questions related to the paragraph</ListItem>
            </List>
          </>
        );
        break;
      case 'Audio Question':
        instructions = (
          <>
            <SectionTitle>Audio Question Instructions</SectionTitle>
            <List>
              <ListItem>Listen carefully to the audio clip - you can only play it once</ListItem>
              <ListItem>Pay attention to details, tone, and context</ListItem>
              <ListItem>Answer the questions based on what you hear</ListItem>
            </List>
          </>
        );
        break;
      case 'Video Response':
        instructions = (
          <>
            <SectionTitle>Video Response Instructions</SectionTitle>
            <List>
              <ListItem>Record a video response to the prompt</ListItem>
              <ListItem>Minimum number of words to be spoken - <strong>50</strong></ListItem>
              <ListItem>Maximum time for response - <strong>2 mins</strong></ListItem>
              <ListItem>Speak clearly and maintain appropriate eye contact with the camera</ListItem>
              <ListItem>You can re-record up to 3 times</ListItem>
              <ListItem>Each recording will replace your previous attempt</ListItem>
            </List >
          </>
        );
        break;
      default:
        instructions = null;
    }

    return instructions ? (
      <InstructionSection>
        {instructions}
        <StyledDivider />
        {/* <hr style={sectionDivider} /> */}
      </InstructionSection>
    ) : null;
  };

  return isCompleted ? (
    <Completion assessmentData={assessment} submittedTime={timeLeft} />
  ) : (
    <PageContainer>
      <AssessmentTimer>{formatTime(timeLeft)}</AssessmentTimer>
      <ContentWrapper>
        <Header>
          <Title>Communication Assessment</Title>
        </Header>
        <NavigationSection>
          {questions.map((section, index) => (
            <QuestionTypeBox
              key={index}
              type={section.type}
              isActive={index === currentPage}
              onClick={() => setCurrentPage(index)}
              index={index}
              isCompleted={isSectionAnswered(section)}
              isVisited={visitedSections.includes(index)}
            />
          ))}
        </NavigationSection>

        <Section>
          <SectionInstructions sectionType={currentSection.type} />
          {currentSection.type === 'Audio Question' &&
            currentSection.paragraph && (
              <div>
                <AudioPlayer
                  url={currentSection.audioUrl}
                  onAudioComplete={() => handleAudioComplete(currentSection.questionId)}
                  isAlreadyCompleted={completedAudioSections.includes(currentSection.questionId)}
                  initialPosition={audioPositions[currentSection.questionId] || 0}
                  onTimeUpdate={(time) => handleAudioProgress(currentSection.questionId, time)}
                />
                {!completedAudioSections.includes(currentSection.questionId) && (
                  <Note>
                    Note: You can listen to this audio only once, so please pay
                    careful attention.
                  </Note>
                )}
              </div>
            )}
          {currentSection.type !== 'Audio Question' &&
            currentSection.paragraph && (
              <Paragraph>
                {formatParagraphWithSpacing(currentSection.paragraph).map(
                  (para, index) => (
                    <React.Fragment key={index}>
                      {para}
                      {index <
                        formatParagraphWithSpacing(currentSection.paragraph)
                          .length -
                        1 && <div style={{ margin: '1rem 0' }}></div>}
                    </React.Fragment>
                  )
                )}
              </Paragraph>
            )}
          {currentSection.type === 'Paragraph Reading' && (

            <AudioContainer>
              <RecordingControls>
                {!audioBlob && (
                  <RedRecordButton
                    onClick={
                      audioRecording ? stopAudioRecording : startAudioRecording
                    }
                  >
                    <RecordIcon />
                    {audioRecording ? 'Stop Recording' : 'Record audio as you read the paragraph'}
                  </RedRecordButton>
                )}
                {!audioBlob && !audioRecording && (
                  <Note>
                    Note: You can only record once, so please make sure you're ready before hitting record!
                  </Note>
                )}
                {audioBlob && (
                  <Note>
                    Your audio has been recorded successfully.
                  </Note>
                )}
                <QuestionInstruction>
                  Select the right answer from the questions below:
                </QuestionInstruction>
              </RecordingControls>
            </AudioContainer>
          )}

          {/* Show instruction only for Audio Question sections */}
          {currentSection.type === 'Audio Question' &&
            currentSection.questions.length > 0 && (
              <QuestionInstruction>
                Select the right answer from the questions below:
              </QuestionInstruction>
            )}

          {currentSection.questions.map((question, questionIndex) => {
            const isDisabled = currentSection.type === 'Paragraph Reading' && !audioBlob;
            const QuestionComponent = isDisabled ? DisabledQuestion : Question;

            return (
              <QuestionComponent key={questionIndex}>
                <QuestionText>
                  {question.question}
                </QuestionText>
                {question.options && (
                  <Options>
                    {question.options.map((option, optionIndex) => (
                      <Option key={optionIndex}>
                        <input
                          type="radio"
                          name={`question-${currentPage}-${questionIndex}`}
                          value={option}
                          onChange={() =>
                            handleOptionSelect(
                              currentSection.questionId,
                              question.id,
                              option
                            )
                          }
                          disabled={isDisabled}
                          checked={
                            responses[
                              currentSection.type === 'Paragraph Reading'
                                ? 'paragraphReading'
                                : 'audioQuestion'
                            ]
                              ?.find(
                                q => q.questionId === currentSection.questionId
                              )
                              ?.responses?.find(
                                r => r.subQuestionId === question.id
                              )?.selectedOption === option
                          }
                        />
                        {option}
                      </Option>
                    ))}
                  </Options>
                )}
              </QuestionComponent>
            );
          })}
        </Section>
        {currentSection.type === 'Video Response' && renderVideoSection()}
        <NavigationButtons>
          <StyledButton onClick={handlePrevious} disabled={currentPage === 0}>
            Back
          </StyledButton>
          {currentPage === questions.length - 1 ? (
            <StyledButton
              variant="primary"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </StyledButton>
          ) : (
            <StyledButton variant="primary" onClick={handleNext}>
              Next
            </StyledButton>
          )}
          <StyledButton
            skip
            onClick={handleNext}
            disabled={currentPage === questions.length - 1}
          >
            Skip
          </StyledButton>
        </NavigationButtons>
      </ContentWrapper>
    </PageContainer>
  )
}

export default CommunicationAssessment
